import { render, staticRenderFns } from "./StringOverride.vue?vue&type=template&id=5b9d7c3b"
import script from "./StringOverride.vue?vue&type=script&lang=js"
export * from "./StringOverride.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports